/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./category-i18n-dialog.vue?vue&type=template&id=55138380&"
import script from "./category-i18n-dialog.vue?vue&type=script&lang=js&"
export * from "./category-i18n-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports